import { useState ,useEffect,useRef } from "react"
import { Time } from "react-ionicons";
import Lottie from "lottie-react";
import "../../index.css"
import loadingAnimation from "./loading.json"
import animattionData from "./Animation - 1724341893745.json"
function DemoSections(){ 

  const [loading, setIsLoading] = useState(true);
  
  const [showAnimate, setShowAnimate] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3500);
    const timer1 = setTimeout(() => {
      setShowAnimate(true)
    }, 6000);
    return () => clearTimeout(timer);
  }, []);


    const sectionsRef = useRef<NodeListOf<HTMLAnchorElement> | null>(null);

    useEffect(() => {
      sectionsRef.current = document.querySelectorAll('.section');
  
      let currentIndex = 0;
  
      const showSection = () => {
        if (!sectionsRef.current) return;
  
        if (currentIndex > 0) {
          sectionsRef.current[currentIndex - 1].classList.remove('blinking');
        }
  
        if (currentIndex < sectionsRef.current.length) {
          sectionsRef.current[currentIndex].classList.add('blinking');
          currentIndex++;
        } else {
          currentIndex = 0; // Recommencer à la première section
        }
      };
  
      const interval = setInterval(showSection, 2000);
  
      return () => clearInterval(interval); // Nettoyage lors du démontage du composant
    }, []);

    return (
        <>
  {loading === false ?<>
<div className=" px-12 py-10 sm:px-6 lg:px-12 lg:py-8 mx-auto">
<div className="grid grid-cols-1 gap-3 lg:grid-cols-3 lg:gap-8">
  <div className="h-32 rounded-lg bg-white border-gray-200 border-2 lg:col-span-2">
  <div className="px-5 py-5 sm:px-6 lg:px-8 lg:py-8 mx-auto ">
      <h2 className="text-xl text-primary font-bold lg:text-4xl dark:text-white">
      Commencer l’évaluation SSI 
   
     
      </h2>
      <p className="mt-3 text-gray-800 dark:text-neutral-400">
      <h3 className="mt-0.5 text-lg text-gray-900">Niveau 2  : 0/120 critères</h3>
     </p>
    </div>
  </div>
  <div className="h-auto rounded-lg border-gray-200 border-2 ">
  <div className=" text-sm text-gray-500 hover:text-blue-600 focus:outline-none focus:text-blue-600 dark:text-neutral-500 dark:hover:text-blue-500 dark:focus:text-blue-500" >
    <div className="bg-white   sm:p-6 px-5  cursor-pointer">
    <div className="mt-0 flex flex-wrap gap-1">
<Time/> Durée : 2 semaines -
</div>
<p className="mt-2 line-clamp-3 text-lg text-gray-500">
       <b className="text-red-500">(5)</b> Documents nécessaires
    </p>
    <span
        className="whitespace-nowrap rounded-full bg-purple-100 mt-3   px-3 lg:px-5 lg:py-1 text-lg text-purple-600"
      >
        ISO27001
      </span>
  </div>
    </div>
  </div>
</div>
  
  

  

</div>

        <div className=" px-10 py-10 sm:px-6 lg:px-14 lg:py-8 mx-auto">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-3 sm:gap-6">
        <a className=" group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
  <div className="p-4 md:p-5">
    <div className="flex justify-between items-center gap-x-3">
      <div className="grow">
        <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
          Section 1 
        </h3>
        <p className="text-sm text-gray-500 dark:text-neutral-500">
          Gouvernance (9 questions)
        </p>
      </div>
      <div>
        <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </div>
    </div>
  </div>
</a>
<a className={`${showAnimate === true ? "combinedAnimation" : ""}  group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800 `} href="/demo/progress">

{showAnimate === true && 
<Lottie 
      animationData={animattionData} 
      loop={true} 
  className="absolute w-100 h-40 mr-59 flex justify-end "
    />}
  <div className="p-4 md:p-5">
    <div className="flex justify-between items-center gap-x-3">
   
      <div className="grow">
    
        <h3 className="group-hover:text-blue-600 font-bold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
          Section 2
        </h3>
        <p className="text-sm text-gray-500 dark:text-neutral-500">
          Sécurité physique (8 questions)
        </p>
      </div>
      <div>
        <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
      </div>
    </div>
  </div>
</a>

          <a className="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
            <div className="p-4 md:p-5">
              <div className="flex justify-between items-center gap-x-3">
                <div className="grow">
                  <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
                  Section 3 
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-neutral-500">
                  Opérations (16 questions)
                  </p>
                </div>
                <div>
                  <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </div>
          </a>
          <a className="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
            <div className="p-4 md:p-5">
              <div className="flex justify-between items-center gap-x-3">
                <div className="grow">
                  <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
                  Section 4  
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-neutral-500">
                  Contrôle d'Accès et Chiffrement (12 questions)
                  </p>
                </div>
                <div>
                  <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </div>
          </a>
          <a className="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
            <div className="p-4 md:p-5">
              <div className="flex justify-between items-center gap-x-3">
                <div className="grow">
                  <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
                  Section 5 
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-neutral-500">
                  Continuité d'Activité (4 questions)
                  </p>
                </div>
                <div>
                  <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </div>
          </a>
          <a className="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
            <div className="p-4 md:p-5">
              <div className="flex justify-between items-center gap-x-3">
                <div className="grow">
                  <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
                  Section 6 
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-neutral-500">
                  Conformité (7 questions)
                  </p>
                </div>
                <div>
                  <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </div>
          </a>
          <a className="group flex flex-col bg-white border shadow-sm rounded-xl hover:shadow-md focus:outline-none focus:shadow-md transition dark:bg-neutral-900 dark:border-neutral-800" href="#">
            <div className="p-4 md:p-5">
              <div className="flex justify-between items-center gap-x-3">
                <div className="grow">
                  <h3 className="group-hover:text-blue-600 font-semibold text-gray-800 dark:group-hover:text-neutral-400 dark:text-neutral-200">
                  Section 7 
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-neutral-500">
                  Gestion des Fournisseurs (4 questions)
                  </p>
                </div>
                <div>
                  <svg className="shrink-0 size-5 text-gray-800 dark:text-neutral-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </div>
          </a>
        </div>
      
      </div>
      </>:  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
<Lottie 
animationData={loadingAnimation} 
loop={true} 
className="absolute w-100 h-40 mr-59 flex justify-end "
/>
</div>
 }
</>
)



}
export default DemoSections